<template>
	<v-dialog :fullscreen="isMobile" v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title class="headline modal__title">
				<button type="button" class="btn-flat-icon--dark" @click="open=false"><v-icon large>fal fa-times</v-icon></button>
			</v-card-title>
			<v-card-text class="modal__card-text basic-modal-padding pl-0 pr-0">
				<div style="color: #666; font-size: 0.9em;">
					<v-stepper v-model="confirmationStep" vertical class="elevation-0">
						<v-stepper-step class="hover" step="1" :complete="!!user.email" @click.native="confirmationStep=1">
							<!-- EMAIL -->
							<p style="color: #777;" class="mb-0">The best email for me is...</p>
						</v-stepper-step>
						<v-stepper-content step="1">
							<input id="number" class="hosted-field" v-model="computedEmail" :style="getInputStyle">
							<p style="font-size: 0.9em;" class="mb-0 error--text"><span v-if="!validEmail">Please enter a valid email address</span><span v-else>&nbsp;</span></p>
							<v-btn color="info" @click.native="confirmationStep++">Continue</v-btn>
						</v-stepper-content>
						<v-stepper-step class="hover" step="2" :complete="password_set"  @click.native="confirmationStep=2">
							<!-- PASSWORD -->
							<p style="color: #777;" class="mb-0">Set a password</p>
						</v-stepper-step>
						<v-stepper-content step="2">
							<v-form v-model="valid" ref="form" lazy-validation>
								<p>You already set a password!</p>
								<p v-if="password_set"><i>You may change your password here.  This is not required.</i></p>
								<v-text-field
									v-if="password_set"
									v-model="oldPassword"
									label="Old Password (if applicable)"
									min="8"
									:append-icon="e1 ? 'visibility' : 'visibility_off'"
									:append-icon-cb="() => (e1 = !e1)"
									:type="e1 ? 'password' : 'text'"
									counter
								></v-text-field>
								<v-text-field
									v-model="newPassword"
									label="New Password"
									min="8"
									:rules="[rules.required, rules.min_length, rules.include_lower, rules.include_upper, rules.include_number, rules.include_special]"
									:append-icon="e2 ? 'visibility' : 'visibility_off'"
									:append-icon-cb="() => (e2 = !e2)"
									:type="e2 ? 'password' : 'text'"
									counter
								></v-text-field>
								<v-text-field
									v-model="confirmPassword"
									label="Confirm Password"
									min="8"
									:rules="[rules.required, rules.password_match]"
									:append-icon="e3 ? 'visibility' : 'visibility_off'"
									:append-icon-cb="() => (e3 = !e3)"
									:type="e3 ? 'password' : 'text'"
									counter
								></v-text-field>
								<div
									style="color: red;"
									v-for="e in error"
									:key="e"
								>
									{{ e }}
								</div>
								<div style="color: green;">
									{{ success }}
								</div>
								<v-btn @click="updatePassword" :disabled="!valid" :loading="passwordSaving">
									Update Password
								</v-btn>
								<v-btn color="info" @click.native="confirmationStep++">Continue</v-btn>
							</v-form>
						</v-stepper-content>
						<v-stepper-step class="hover" step="3" :complete="!!user.where_from" @click.native="confirmationStep=3">
							<!-- Where did you hear about wrkprty -->
							<p style="color: #777;" class="mb-0">Where did you hear about us?</p>
						</v-stepper-step>
						<v-stepper-content step="3">
							<v-select
								placeholder="Select"
								id="where-from-input"
								class="pt-0"
								:items="choices"
								v-model="whereFrom"
								hide-details
								single-line
								required
							></v-select>
							<v-btn color="info" @click.native="confirmationStep++">Continue</v-btn>
						</v-stepper-content>
						<v-stepper-step class="hover" step="4" :complete="!!user.bio" @click.native="confirmationStep=4">
							<!-- User Bio -->
							<p style="color: #777;" class="mb-0">Bio</p>
						</v-stepper-step>
						<v-stepper-content step="4">
							<div class="gray--text">Your personal description; Hosts and other users will see this.</div>
							<v-textarea
								color="link"
								rows="1"
								label="Edit Bio"
								class="mt-2 pr-2"
								v-model="userBio"
							></v-textarea>
							<v-btn color="info" @click.native="confirmationStep++">Continue</v-btn>
						</v-stepper-content>
						<v-stepper-step class="hover" step="5" :complete="!!user.interests" @click.native="confirmationStep=5">
							<!-- User Interests -->
							<p style="color: #777;" class="mb-0">What are your interests?</p>
						</v-stepper-step>
						<v-stepper-content step="5">
							<div class="caption gray-text">This will help us suggest and plan more events that you will enjoy!</div>
							<v-select
								color="link"
								v-model="userInterests"
								label="Interests"
								deletable-chips
								chips
								tags
								:items="interestOptions"
							></v-select>
							<v-btn color="info" @click.native="confirmationStep++">Continue</v-btn>
						</v-stepper-content>
						<v-stepper-step class="hover" step="6" :complete="!!user.gender" @click.native="confirmationStep=6">
							<!-- Gender -->
							<p style="color: #777;" class="mb-0">What gender do you identify with?</p>
						</v-stepper-step>
						<v-stepper-content step="6">
							<v-select
								placeholder="Select"
								id="gender-input"
								class="pt-0"
								:items="genderOptions"
								v-model="userGender"
								hide-details
								single-line
								required
							></v-select>
							<v-btn color="info" @click.native="confirmationStep++">Continue</v-btn>
						</v-stepper-content>
					</v-stepper>
					<div class="pr-4 pl-4">
						<div style="width: 100%" class="text-xs-center">
							<v-btn class="btn-blue mt-3 hidden-xs-only elevation-0" @click="saveInfo" :disabled="getFormInvalid" :loading="confirmationLoading" style="width: 80%; height: 60px; border-radius: 10px;">Looks Good</v-btn>
						</div>
					</div>
				</div>
				<div>
					<img class="event-page-flat-logo mb-3 mt-3" src="/static/images/wrkprty-flattened-logo.png" alt="">
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'

import { rawAxiosGet } from '~/plugins/rawAxios'
import { isEmpty } from '~/store/util/util'
import * as TYPE from '~/store/util/types'

export default {
	name: 'user-confirmation-modal',
	$validates: true,
	data () {
		return {
			confirmationLoading: false,
			confirmationStep: 1,
			password_set: false,
			pk: '',
			genderOptions: ['Male', 'Female', 'Other'],
			day: null,
			month: null,
			year: null,
			acceptedTerms: false,
			email: '',
			emailAddresses: [],
			valid: false,
			validEmail: false,
			// Password fields
			e1: true,
			e2: true,
			e3: true,
			error: [],
			success: null,
			passwordSaving: false,
			oldPassword: '',
			newPassword: '',
			confirmPassword: '',
			// Where from choices
			choices: [
				{text: 'Other', value: 'other'},
				{text: 'Meetup', value: 'meetup'},
				{text: 'Eventbrite', value: 'eventbrite'},
				{text: 'Built In LA', value: 'builtinla'},
				{text: 'From a friend', value: 'friend'},
				{text: 'Facebook', value: 'facebook'},
				{text: 'Instagram', value: 'instagram'},
				{text: 'Google', value: 'google'},
				{text: 'Twitter', value: 'twitter'},
			],
			interestOptions: [
				'Angel Investing',
				'Animation',
				'Art',
				'Cinematography',
				'Community Development',
				'Construction',
				'Consulting',
				'Entrepreneurship',
				'Filmmaking',
				'Films',
				'Finance',
				'Food',
				'Hack-a-thons',
				'Insurance',
				'Marketing',
				'Photography',
				'Politics',
				'Programming',
				'Real Estate',
				'Restaurants',
				'Robotics',
				'Sales',
				'Science',
				'Sports',
				'Startups',
				'Tech',
				'Transportation',
				'Travel',
				'Venture Capital',
				'Visual Effects',
				'Writing'
			],
			nameRules: [
				(v) => !!v || 'Name is required',
				(v) => v.length <= 20 || 'Name must be less than 20 characters'
			],
			emailRules: [
				(v) => !!v || 'E-mail is required',
				(v) => {
					let result = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(v)
					this.validEmail = result
					return result
				}
			],
			rules: {
				required: value => !!value || 'Required.',
				min_length: value =>
					value.length > 7 || 'Minimum length is 8 characters',
				include_lower: value => {
					return /.*[a-z].*/.test(value) || 'Must include a lowercase letter'
				},
				include_upper: value => {
					return /.*[A-Z].*/.test(value) || 'Must include an uppercase letter'
				},
				include_number: value => {
					return /.*[0-9].*/.test(value) || 'Must include a number'
				},
				include_special: value => {
					return (
						/.*[!@#$%^*?&~=+|\\\/\(\)\{\[\]}\-_\<\>\.].*/.test(value) ||
						'Must include a special character'
					)
				},
				password_match: value => {
					return this.newPassword === value || "Passwords don't match"
				}
			}
		}
	},
	mounted () {
		this.email = this.user.email
		let result = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(this.email)
		this.validEmail = result
	},
	methods: {
		...mapActions([
			'serverPutUserProp',
			'setModalOpen',
			'setAuthRedirect',
			'setUserProp',
			'setUserSocial',
			'logout'
		]),
		grabConfirmationdata() {
			axios
				.get('/api/v1/user-confirmation-data/')
				.then(response => {
					this.emailAddresses = response.data.emailaddresses
					this.password_set = response.data.password_set
					this.setUserProp({ password_set: this.password_set, emailAddresses: this.emailAddresses })
				})
				.catch(error => {
					console.error(error)
				})
		},
		saveInfo () {
			this.confirmationLoading = true
			const userProps = {
				'id': this.user.pk,
				'email': this.email,
				'bio': this.userBio,
				'interests': this.userInterests.join(','),
				'where_from': this.whereFrom,
				'gender': this.userGender,
			}
			this.setUserProp(userProps)
				.then((response) => {
					axios.post('/api/v1/user/confirmation/', userProps)
						.then((response) => {
							this.confirmationLoading = false
							this.setUserProp({ active: true })
							this.setUserSocial(this.user)
							this.setModalOpen({prop: 'registrationConfirmationModal', value: false})
						})
						.catch((error) => {
							this.confirmationLoading = false
							console.error(error)
						})
				})
				.catch((error) => {
					this.confirmationLoading = false
					console.error(error)
				})
		},
		updatePassword() {
			if (this.$refs.form.validate()) {
				this.passwordSaving = true
				if (this.newPassword === this.confirmPassword) {
					axios
						.put('/api/v1/settings/change-password/', {
							old_password: this.oldPassword ? this.oldPassword : '12345',
							new_password: this.newPassword
						})
						.then(response => {
							this.password_set = true
							this.passwordSaving = false
							this.error = []
							this.success = response.data
						})
						.catch(error => {
							this.passwordSaving = false
							console.error(error)
							this.error = []
							for (let i in error.response.data) {
								this.error.push(error.response.data[i])
							}
						})
				} else {
					this.error = ['Password and confirmation do not match']
				}
			}
		}
	},
	computed: {
		...mapGetters([
			'getAuthRedirect',
			'user',
			'getModalProp'
		]),
		userGender: {
			get () {
				return this.user.gender
			},
			set (val) {
				this.setUserProp({ gender: val })
			}
		},
		userBio: {
			get () {
				return this.user.bio
			},
			set (val) {
				this.setUserProp({ bio: val })
			}
		},
		whereFrom: {
			get () {
				return this.user.where_from
			},
			set (val) {
				this.setUserProp({ where_from: val })
			}
		},
		userInterests: {
			get () {
				if (this.user.interests === '') {
					return []
				}
				return this.user.interests.split(',')
			},
			set (val) {
				this.setUserProp({ interests: val.join(',') })
			}
		},
		computedEmail: {
			get () {
				return this.user.email
			},
			set (val) {
				let result = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(val)
				this.validEmail = result
				this.email = val
				this.user.email = val
			}
		},
		getFormInvalid () {
			return !this.validEmail || this.whereFrom === null
		},
		months () {
			let months = []
			let m = moment.months()
			for (let i = 0; i < m.length; i++) {
				months.push({
					value: i + 1,
					name: m[i]
				})
			}
			return months
		},
		days () {
			return Array(31).fill().map((e, i) => i + 1)
		},
		years () {
			return Array(100).fill().map((e, i) => i + 1918 - 18).reverse()
		},
		getInputStyle () {
			if (!this.validEmail) {
				return {
					'border-bottom': '2px solid #de6455',
					'transition': 'all 200ms ease'
				}
			}
		},
		open: {
			get () {
				let value = this.getModalProp('registrationConfirmationModal')
				if (value) {
					this.grabConfirmationdata()
				}
				return value
			},
			set (val) {
				this.setModalOpen({prop: 'registrationConfirmationModal', value: val})
			}
		},
		isMobile () {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	},
}
</script>

<style lang="scss">

.hover {
	cursor: pointer;
}

.nav-container {
    overflow: hidden;
}
.unskew {
	margin: 14px 40px;
	-webkit-transform: skew(20deg);
       -moz-transform: skew(20deg);
         -o-transform: skew(20deg);
}
#parallelogram {
	min-width: 150px;
	width: 15%;
    height: 64px;
    margin: 0 0 0 -20px;
    -webkit-transform: skew(-20deg);
       -moz-transform: skew(-20deg);
         -o-transform: skew(-20deg);
    background: #f3f3f3;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
}

.hosted-field {
	height: 45px;
	display: block;
	background-color: transparent;
	color: #666;
	border: none;
	border-bottom: 1px solid rgba(0, 0, 0, .54);
	outline: 0;
	width: 100%;
	font-size: 25px;
	padding: 0;
	box-shadow: none;
	border-radius: 0;
	position: relative;
	&:focus {
		border-bottom: 2px solid #74cbf1;
		transition: all 200ms ease;	
	}
}

@media screen and (max-width: 1264px) {
	.first-column {
		margin-bottom: 15px;
		height: auto!important;
		>div {
			height: auto!important;
		}
	}
    .form-container {
    	height: auto!important;
    	padding: 90px 10px 50px 10px!important;
    }
}
@media screen and (min-width: 960px) {
    .border-right-md {
		border-right: 3px solid #f0f0f0;
	}
}

</style>
